<syslink-wysiwyg
    name="Note"
    label="Note"
    [(model)]="element.Note"
    [table]="false"
    [multilineToolbar]="true"
    height="200"
></syslink-wysiwyg>